import { URLS } from 'api/constants';
import { apiGet, apiRequest } from 'lib/api/client';
import { useMutation } from 'hooks/useMutation';
import { getUtm } from 'utils/storage';

type MagicLinkParams = {
  email?: string;
};

type GoogleAuthParams = {
  oauthToken: string;
};

export const useMagicLinkMutation = () =>
  useMutation<MagicLinkParams, void>(({ email }) =>
    apiRequest<void>(URLS.MAGIC_LINK, {
      method: 'POST',
      body: { email, ...getUtm() },
    })
  );

export const useGoogleAuthMutation = () =>
  useMutation<GoogleAuthParams, { authToken: string }>(({ oauthToken }) => {
    const params = new URLSearchParams({ oauthToken });
    const utm = getUtm();

    Object.entries(utm).forEach(([key, value]) => {
      if (value) {
        params.append(key, value);
      }
    });

    return apiRequest<{ authToken: string }>(
      `${URLS.GOOGLE_AUTH}?${params.toString()}`,
      {
        method: 'GET',
      }
    );
  });

export const useGoogleLinkMutation = () =>
  useMutation<GoogleAuthParams, void>(({ oauthToken }) =>
    apiGet<void>(URLS.GOOGLE_LINK, { oauthToken }, { auth: true })
  );

export const useGoogleUnlinkMutation = () =>
  useMutation<void, void>(() =>
    apiGet<void>(URLS.GOOGLE_UNLINK, undefined, { auth: true })
  );
